import LogoutButton from './LogoutButton';
import { useState } from 'react'
import { Dialog } from '@headlessui/react'
import { HashLink as Link } from 'react-router-hash-link';
import {
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline'

export default function Header({ isAuthenticated, loginWithRedirect }) {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header className="sticky z-20">
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
        <div className="flex lg:flex-1">
          <a href="/" className="-m-1.5 p-1.5">
            {!mobileMenuOpen && (
              <>
              <span className="sr-only">AI Betting Assistant</span>
              <img className="h-14 w-auto" src="/sagewager_logo.png" alt="Logo" />
              </>
            )}
          </a>
        </div>
        <div className="flex lg:hidden">
          {!mobileMenuOpen && (
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(true)}
            >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
          )}
        </div>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
        {isAuthenticated ? (
          <>
            <Link 
              className="bg-emerald-600 hover:bg-emerald-900 text-white font-bold py-2 px-4 mx-4 rounded"
              to="/chat"
            >
              My SageWager
            </Link>
            <LogoutButton />
        </>
            ) : (
            <button 
                className="bg-emerald-600 hover:bg-emerald-900 text-white font-bold py-2 px-4 rounded"
                onClick={loginWithRedirect}
            >
                Login
            </button>
            )}

        </div>
      </nav>
      <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">SageWager</span>
              <img
                className="h-8 w-auto"
                src="/sagewager_logo.png"
                alt=""
              />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
              <a 
                href="/chat" 
                className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                onClick={() => setMobileMenuOpen(false)}
              >
                My SageWager
              </a>
              </div>
              <div className="py-6">
              {isAuthenticated ? (
                <LogoutButton />
                ) : (
                <button
                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    onClick={loginWithRedirect}
                >
                    Login
                </button>
                )}
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  )
}
